export default __webpack_public_path__ + "static/media/khaki.bb24479b.jpg";